module.exports = __webpack_public_path__ + "static/media/100_11.336faadc.jpg";